There was an error on
@if (infoService.errorPath) {
    <span
        ><strong>{{ infoService.errorPath }}</strong>
    </span>
}
